export const FEE_COLLECTION_FORM_CONFIG = {
  INSTALLMENT_SELECTION: {
    label: 'Installment Selection at Fee Collection by Staff',
    fields: [
      {
        type: 'radio',
        label: ' Allow Continuous Selection Only',
        value: 'CONTINUOUS',
        name: 'INSTALLMENT_SELECTION',
        id: 'INSTALLMENT_SELECTION-CONTINUOUS',
      },
      {
        type: 'radio',
        value: 'RANDOM',
        label: 'Random Installments Selection',
        id: 'INSTALLMENT_SELECTION-RANDOM',
        name: 'INSTALLMENT_SELECTION',
      },
    ],
    colSpan: 3,
  },
  INSTALLMENT_SELECTION_STUDENT: {
    label: 'Installment Selection at Online Payment by Student',
    fields: [
      {
        type: 'radio',
        label: ' Allow Continuous Selection Only',
        value: 'CONTINUOUS',
        name: 'INSTALLMENT_SELECTION_STUDENT',
        id: 'INSTALLMENT_SELECTION_STUDENT-CONTINUOUS',
        size: 'lg',
      },
      {
        type: 'radio',
        label: 'Random Installments Selection',
        value: 'RANDOM',
        id: 'INSTALLMENT_SELECTION_STUDENT-RANDOM',
        name: 'INSTALLMENT_SELECTION_STUDENT',
        size: 'lg',
      },
    ],
    colSpan: 3,
  },
  PAYMENT_AMOUNT_OF_MONTHS: {
    label: 'Partial Payment Of Selected Months',
    fields: [
      {
        type: 'radio',
        label: 'Allow Partial Payment Of Months',
        value: 'PARTIAL',
        name: 'PAYMENT_AMOUNT_OF_MONTHS',
        id: 'PAYMENT_AMOUNT_OF_MONTHS-PARTIAL',
        size: 'lg',
      },
      {
        type: 'radio',
        value: 'COMPLETE',
        label: ' Do Not Allow Partial Payment',
        id: 'PAYMENT_AMOUNT_OF_MONTHS-COMPLETE',
        name: 'PAYMENT_AMOUNT_OF_MONTHS',
        size: 'lg',
      },
    ],
    colSpan: 3,
  },
  CANCEL_RECEIPT_AT_FEE_COLLECTION: {
    label: 'Cancel Receipt Button At Fee Collection',
    fields: [
      {
        type: 'radio',
        label: 'Allow Cancel Receipt',
        value: 'INCLUDE_BUTTON',
        name: 'CANCEL_RECEIPT_AT_FEE_COLLECTION',
        id: 'CANCEL_RECEIPT_AT_FEE_COLLECTION-INCLUDE_BUTTON',
        size: 'lg',
      },
      {
        type: 'radio',
        value: 'DONT_INCLUDE_BUTTON',
        label: 'Do Not Allow Cancel Receipt',
        id: 'CANCEL_RECEIPT_AT_FEE_COLLECTION-DONT_INCLUDE_BUTTON',
        name: 'CANCEL_RECEIPT_AT_FEE_COLLECTION',
        size: 'lg',
      },
    ],
    colSpan: 3,
  },
  RECEIPT_CANCELLATION_DATE: {
    label: 'Back Date Receipt Cancellation',
    fields: [
      {
        label: 'Allow Back Date Cancellation',
        type: 'radio',
        value: 'BACKDATE_ALLOWED',
        id: 'RECEIPT_CANCELLATION_DATE-BACKDATE_ALLOWED',
        name: 'RECEIPT_CANCELLATION_DATE',
      },
      {
        label: 'Do Not Allow Back Date',
        type: 'radio',
        value: 'CURRENT_DAY_ONLY',
        id: 'RECEIPT_CANCELLATION_DATE-CURRENT_DAY_ONLY',
        name: 'RECEIPT_CANCELLATION_DATE',
      },
    ],
    colSpan: 3,
  },
  RECEIPT_ENTRY_DATE: {
    label: 'Back Date Fee Receipt Entry',
    fields: [
      {
        type: 'radio',
        name: 'RECEIPT_ENTRY_DATE',
        id: 'RECEIPT_ENTRY_DATE-BACKDATE_ALLOWED',
        value: 'BACKDATE_ALLOWED',
        label: 'Allow Back Date Payment',
      },
      {
        type: 'radio',
        name: 'RECEIPT_ENTRY_DATE',
        id: 'RECEIPT_ENTRY_DATE-CURRENT_DAY_ONLY',
        value: 'CURRENT_DAY_ONLY',
        label: 'Do Not Allow Back Date',
      },
    ],
    colSpan: 3,
  },
  PYDUES_PAYMENT_PRIORITY: {
    label: 'Previous Year Dues Collection Priority',
    fields: [
      {
        type: 'radio',
        name: 'PYDUES_PAYMENT_PRIORITY',
        id: 'PYDUES_PAYMENT_PRIORITY-FIRST',
        value: 'FIRST',
        label: 'Mandatory With Current Fee',
      },
      {
        type: 'radio',
        name: 'PYDUES_PAYMENT_PRIORITY',
        id: 'PYDUES_PAYMENT_PRIORITY-SECOND',
        value: 'SECOND',
        label: 'Optional With Current Fee',
      },
    ],
    colSpan: 3,
  },
  PAYMENT_REMARKS_ENTRY: {
    label: 'Payment Remarks Entry',
    fields: [
      {
        type: 'radio',
        name: 'PAYMENT_REMARKS_ENTRY',
        id: 'PAYMENT_REMARKS_ENTRY-MANDATORY',
        value: 'MANDATORY',
        label: 'Mandatory',
      },
      {
        type: 'radio',
        name: 'PAYMENT_REMARKS_ENTRY',
        id: 'PAYMENT_REMARKS_ENTRY-NOT_MANDATORY',
        value: 'NOT_MANDATORY',
        label: 'Not Mandatory',
      },
    ],
    colSpan: 3,
  },
  NO_OF_PAYMENT_MODES: {
    label: 'Multimode Payment',
    fields: [
      {
        type: 'radio',
        name: 'NO_OF_PAYMENT_MODES',
        id: 'NO_OF_PAYMENT_MODES-MULTIMODE',
        value: 'MULTIMODE',
        label: 'Allow Multimode Payment',
      },
      {
        type: 'radio',
        name: 'NO_OF_PAYMENT_MODES',
        id: 'NO_OF_PAYMENT_MODES-SINGLEMODE',
        value: 'SINGLEMODE',
        label: 'Do Not Allow',
      },
    ],
    colSpan: 3,
  },
  HEADS_AMT_ADJUST: {
    label: 'Fee Head Amount Adjustment',
    fields: [
      {
        type: 'radio',
        name: 'HEADS_AMT_ADJUST',
        id: 'HEADS_AMT_ADJUST-ALLOWED',
        value: 'ALLOWED',
        label: 'Allow amount adjustment in last installment',
      },
      {
        type: 'radio',
        name:"HEADS_AMT_ADJUST",
        id: 'NO_OF_PAYMENT_MODES-SINGLEMODE',
        value: 'SINGLEMODE',
        label: 'Do Not Allow',
      },
    ],
    colSpan: 3,
  },
  ZERO_AMT_RECEIPT: {
    label: 'Fee Receipt for Zero Amount',
    fields: [
      {
        type: 'radio',
        name: 'ZERO_AMT_RECEIPT',
        id: 'ZERO_AMT_RECEIPT-ALLOWED',
        value: 'ALLOWED',
        label: 'Allow Generation of Zero Receipt',
      },
      {
        type: 'radio',
        name: 'ZERO_AMT_RECEIPT',
        id: 'ZERO_AMT_RECEIPT-NOT_ALLOWED',
        value: 'NOT_ALLOWED',
        label: 'Do Not Allow',
      },
    ],
    colSpan: 3,
  },
  AUTO_FILL_TOTAL_AMOUNT: {
    label: 'Auto Fill Final Installment Amount',
    fields: [
      {
        type: 'radio',
        name: 'AUTO_FILL_TOTAL_AMOUNT',
        id: 'AUTO_FILL_TOTAL_AMOUNT-TRUE',
        value: 'TRUE',
        label: 'Yes',
      },
      {
        type: 'radio',
        name: 'AUTO_FILL_TOTAL_AMOUNT',
        id: 'AUTO_FILL_TOTAL_AMOUNT-FALSE',
        value: 'FALSE',
        label: 'No',
      },
    ],
    colSpan: 3,
  },
  PY_DUE_SESSIONS: {
    label: 'No. Of Previous Sessions For PY Dues',
    fields: [
      {
        type: 'number',
        name: 'PY_DUE_SESSIONS',
        id: 'PY_DUE_SESSIONS',
        placeholder:
          'Number of Previous Sessions to include in calculation of PY Dues, default is 1',
        label: 'No. Of Previous Sessions For PY Dues',
        min: 1,
        max: 20,
        step: 1,
      },
    ],
    colSpan: 6,
  },
  NUMBER_OF_CONTINUOUS_INSTALLMENT: {
    label: 'No. of Months in Installment Group',
    fields: [
      {
        type: 'number',
        name: 'NUMBER_OF_CONTINUOUS_INSTALLMENT',
        id: 'NUMBER_OF_CONTINUOUS_INSTALLMENT',
        placeholder: '0,1,2,3,4,6 or 12',
        label: 'No. of Months in Installment Group',
        min: 0,
        max: 12,
        step: 1,
      },
    ],
    colSpan: 6,
  },
}

export const FEE_RECEIPT_FORM_CONFIG = {
  FEE_HEADS: {
    label: 'Fee Heads Display in Receipt',
    fields: [
      {
        type: 'radio',
        value: 'PAID_HEADS',
        label: 'Only Paid Heads',
        id: 'FEE_HEADS-PAID_HEADS',
        name: 'FEE_HEADS',
      },
      {
        type: 'radio',
        name: 'FEE_HEADS',
        id: 'FEE_HEADS-UNPAID_HEADS',
        value: 'UNPAID_HEADS',
        label: 'Both Paid & Unpaid Heads',
      },
    ],
  },
  TOTAL_DUES: {
    label: 'Dues Display in Receipt',
    fields: [
      {
        type: 'radio',
        name: 'TOTAL_DUES',
        id: 'TOTAL_DUES-TOTAL_DUE',
        value: 'TOTAL_DUE',
        label: 'Show Dues Master Account Wise',
      },
      {
        type: 'radio',
        name: 'TOTAL_DUES',
        id: 'TOTAL_DUES-TOTAL_PAID_AND_TOTAL_DUE',
        value: 'TOTAL_PAID_AND_TOTAL_DUE',
        label: 'Show Dues of All Master Accounts',
      },
    ],
  },
  PY_DUES: {
    label: 'Previous Year Dues Display in Receipt',
    fields: [
      {
        type: 'radio',
        name: 'PY_DUES',
        id: 'PY_DUES-SHOW',
        value: 'SHOW',
        label: 'Show',
      },
      {
        type: 'radio',
        name: 'PY_DUES',
        id: 'PY_DUES-HIDE',
        value: 'HIDE',
        label: 'Hide',
      },
    ],
  },
  SHOW_INSTRUMENT_DATE: {
    label: 'Instrument Date Display in Receipt',
    fields: [
      {
        type: 'radio',
        name: 'SHOW_INSTRUMENT_DATE',
        id: 'SHOW_INSTRUMENT_DATE-SHOW',
        value: 'SHOW',
        label: 'Show',
      },
      {
        type: 'radio',
        name: 'SHOW_INSTRUMENT_DATE',
        id: 'SHOW_INSTRUMENT_DATE-HIDE',
        value: 'HIDE',
        label: 'Hide',
      },
    ],
  },
  CONCESSION_COL_DISPLAY: {
    label: 'Concession Column Display in Receipt',
    fields: [
      {
        type: 'radio',
        name: 'CONCESSION_COL_DISPLAY',
        id: 'CONCESSION_COL_DISPLAY-SHOW',
        value: 'SHOW',
        label: 'Show',
      },
      {
        type: 'radio',
        name: 'CONCESSION_COL_DISPLAY',
        id: 'CONCESSION_COL_DISPLAY-HIDE',
        value: 'HIDE',
        label: 'Hide',
      },
    ],
  },
  PREVIOUS_PAID_COL_DISPLAY: {
    label: 'Previous Paid Column Display in Receipt',
    fields: [
      {
        type: 'radio',
        name: 'PREVIOUS_PAID_COL_DISPLAY',
        id: 'PREVIOUS_PAID_COL_DISPLAY-SHOW',
        value: 'SHOW',
        label: 'Show',
      },
      {
        type: 'radio',
        name: 'PREVIOUS_PAID_COL_DISPLAY',
        id: 'PREVIOUS_PAID_COL_DISPLAY-HIDE',
        value: 'HIDE',
        label: 'Hide',
      },
    ],
  },
  NOTE_DISPLAY: {
    label: 'Note Display in Receipt',
    fields: [
      {
        type: 'radio',
        name: 'NOTE_DISPLAY',
        id: 'NOTE_DISPLAY-SHOW',
        value: 'SHOW',
        label: 'Show',
      },
      {
        type: 'radio',
        name: 'NOTE_DISPLAY',
        id: 'NOTE_DISPLAY-HIDE',
        value: 'HIDE',
        label: 'Hide',
      },
    ],
  },
  RECEIPT_NOTE: {
    label: 'Note',
    fields: [
      {
        type: 'text-area',
        name: 'RECEIPT_NOTE',
        id: 'RECEIPT_NOTE',
        maxlength: '500',
        placeholder: 'Use <br> for new line.',
        label: 'Note',
        rows: 3,
      },
    ],
    colSpan: 6,
  },
  PAGE_SIZE_WIDTH_HEIGHT: {
    label: 'Receipt Page Size Width-Height',
    fields: [
      {
        type: 'text',
        name: 'PAGE_SIZE_WIDTH_HEIGHT',
        id: 'PAGE_SIZE_WIDTH_HEIGHT',
        placeholder: 'Width in mm - Height in mm, for A4 it is 210-297',
        label: 'Receipt Page Size Width-Height',
      },
    ],
  },
  RECEIPT_MARGIN_LTR: {
    label: 'Receipt Page Margin',
    fields: [
      {
        type: 'number',
        name: 'RECEIPT_MARGIN_LTR',
        id: 'RECEIPT_MARGIN_LTR',
        min: '0',
        step: '0.01',
        placeholder: 'Margin at Left, Top & Right in mm, default is 8',
        label: 'Receipt Page Margin',
      },
    ],
  },
  NUMBER_OF_COPIES: {
    label: 'Number of Copies of Receipt',
    fields: [
      {
        type: 'number',
        name: 'NUMBER_OF_COPIES',
        id: 'NUMBER_OF_COPIES',
        min: '1',
        max: '4',
        step: '1',
        placeholder: 'Number of Copies of Receipt out of 4, default is 2',
        label: 'Number of Copies of Receipt',
      },
    ],
  },
  COPIES_PLACEMENT: {
    label: 'Copies Placement Direction',
    fields: [
      {
        type: 'radio',
        name: 'COPIES_PLACEMENT',
        id: 'COPIES_PLACEMENT-HORIZONTAL',
        value: 'HORIZONTAL',
        label: 'Horizontally One after another',
      },
      {
        type: 'radio',
        name: 'COPIES_PLACEMENT',
        id: 'COPIES_PLACEMENT-VERTICAL',
        value: 'VERTICAL',
        label: 'Vertically One after another',
      },
    ],
  },
  COPY_NAME1: {
    label: 'Receipt First Copy Name',
    fields: [
      {
        type: 'text',
        name: 'COPY_NAME1',
        id: 'COPY_NAME1',
        placeholder: "Office Copy or Student's Copy or Empty",
        label: 'Receipt First Copy Name',
      },
    ],
  },
  COPY_NAME2: {
    label: 'Receipt Second Copy Name',
    fields: [
      {
        type: 'text',
        name: 'COPY_NAME2',
        id: 'COPY_NAME2',
        placeholder: "Office Copy or Student's Copy or Empty",
        label: 'Receipt Second Copy Name',
      },
    ],
  },
  COPY_NAME3: {
    label: 'Receipt Third Copy Name',
    fields: [
      {
        type: 'text',
        name: 'COPY_NAME3',
        id: 'COPY_NAME3',
        placeholder: "Office Copy or Student's Copy or Empty",
        label: 'Receipt Third Copy Name',
      },
    ],
    colSpan: 4,
  },
  COPY_NAME4: {
    label: 'Receipt Fourth Copy Name',
    fields: [
      {
        type: 'text',
        name: 'COPY_NAME4',
        id: 'COPY_NAME4',
        placeholder: "Office Copy or Student's Copy or Empty",
        label: 'Receipt Fourth Copy Name',
      },
    ],
    colSpan: 4,
  },
  SIGN_TYPE: {
    label: 'Receipt Sign Caption Type',
    fields: [
      {
        type: 'radio',
        name: 'SIGN_TYPE',
        id: 'SIGN_TYPE-LABEL',
        value: 'LABEL',
        label: "Label : 'Collection Incharge'",
      },
      {
        type: 'radio',
        name: 'SIGN_TYPE',
        id: 'SIGN_TYPE-STAFF_NAME',
        value: 'STAFF_NAME',
        label: 'Name of Accountant',
      },
    ],
    colSpan: 4,
  },
}

export const LATE_FEE_FORM_CONFIG = {
  PATTERN: {
    label: 'Late Fee System Pattern',
    fields: [
      {
        type: 'radio',
        name: 'PATTERN',
        id: 'PATTERN-OLD',
        value: 'OLD',
        label: 'Use Old',
      },
      {
        type: 'radio',
        name: 'PATTERN',
        id: 'PATTERN-NEW',
        value: 'NEW',
        label: 'Use New',
      },
    ],
    colSpan: 3,
  },
}

export const DCR_FORM_CONFIG = {
  ORIENTATION: {
    label: 'Report Orientation',
    fields: [
      {
        type: 'radio',
        name: 'ORIENTATION',
        id: 'ORIENTATION-LANDSCAPE',
        value: 'LANDSCAPE',
        label: 'Landscape',
      },
      {
        type: 'radio',
        name: 'ORIENTATION',
        id: 'ORIENTATION-PORTRAIT',
        value: 'PORTRAIT',
        label: 'Portrait',
      },
    ],
    colSpan: 3,
  },
  INCLUDE_ZERO_AMOUNT: {
    label: 'Include Zero Amount Heads',
    fields: [
      {
        type: 'radio',
        name: 'INCLUDE_ZERO_AMOUNT',
        id: 'INCLUDE_ZERO_AMOUNT-ALLOWED',
        value: 'ALLOWED',
        label: 'Include Zero Amount Heads',
      },
      {
        type: 'radio',
        name: 'INCLUDE_ZERO_AMOUNT',
        id: 'INCLUDE_ZERO_AMOUNT-DENIED',
        value: 'DENIED',
        label: 'Do Not Include Zero Amount Heads',
      },
    ],
    colSpan: 3,
  },
  TOTAL_FEE_HEAD_COL_P: {
    label: 'Fee Heads Limit (Portrait)',
    fields: [
      {
        type: 'number',
        name: 'TOTAL_FEE_HEAD_COL_P',
        id: 'TOTAL_FEE_HEAD_COL_P',
        min: '1',
        step: '1',
        placeholder: '9',
      },
    ],
    colSpan: 3,
  },
  TOTAL_FEE_HEAD_COL_L: {
    label: 'Fee Heads Limit (Landscape)',
    fields: [
      {
        type: 'number',
        name: 'TOTAL_FEE_HEAD_COL_L',
        id: 'TOTAL_FEE_HEAD_COL_L',
        min: '1',
        step: '1',
        placeholder: '9',
      },
    ],
    colSpan: 3,
  },
  INCLUDE_PETTY_COLLECTION: {
    label: 'Include Petty Collection',
    fields: [
      {
        type: 'radio',
        name: 'INCLUDE_PETTY_COLLECTION',
        id: 'INCLUDE_PETTY_COLLECTION-ALLOWED',
        value: 'ALLOWED',
        label: 'Include',
      },
      {
        type: 'radio',
        name: 'INCLUDE_PETTY_COLLECTION',
        id: 'INCLUDE_PETTY_COLLECTION-DENIED',
        value: 'DENIED',
        label: 'Do Not Include',
      },
    ],
    colSpan: 3,
  },
  PETTY_COLLECTION_REPORT_TYPE: {
    label: 'Petty Collection Report Type',
    fields: [
      {
        type: 'radio',
        name: 'PETTY_COLLECTION_REPORT_TYPE',
        id: 'PETTY_COLLECTION_REPORT_TYPE-SUMMARY',
        value: 'SUMMARY',
        label: 'Only Summary Report',
      },
      {
        type: 'radio',
        name: 'PETTY_COLLECTION_REPORT_TYPE',
        id: 'PETTY_COLLECTION_REPORT_TYPE-DETAILS',
        value: 'DETAILS',
        label: 'Detailed Report',
      },
    ],
    colSpan: 3,
  },
  TOTAL_TRANSACTION_START_PAGE_P: {
    label: 'First Page Rows Limit (Portrait)',
    fields: [
      {
        type: 'number',
        name: 'TOTAL_TRANSACTION_START_PAGE_P',
        id: 'TOTAL_TRANSACTION_START_PAGE_P',
        min: '1',
        step: '1',
        placeholder: '40',
      },
    ],
    colSpan: 3,
  },
  TOTAL_TRANSACTION_START_PAGE_L: {
    label: 'First Page Rows Limit (Landscape)',
    fields: [
      {
        type: 'number',
        name: 'TOTAL_TRANSACTION_START_PAGE_L',
        id: 'TOTAL_TRANSACTION_START_PAGE_L',
        min: '1',
        step: '1',
        placeholder: '30',
      },
    ],
    colSpan: 3,
  },
  INCLUDE_CANCELLED_TABLE: {
    label: 'Include Cancelled Receipts',
    fields: [
      {
        type: 'radio',
        name: 'INCLUDE_CANCELLED_TABLE',
        id: 'INCLUDE_CANCELLED_TABLE-ALLOWED',
        value: 'ALLOWED',
        label: 'Include',
      },
      {
        type: 'radio',
        name: 'INCLUDE_CANCELLED_TABLE',
        id: 'INCLUDE_CANCELLED_TABLE-DENIED',
        value: 'DENIED',
        label: 'Do Not Include',
      },
    ],
    colSpan: 3,
  },
  INCLUDE_CHEQUEBOUNCE_TABLE: {
    label: 'Include Cheque-Bounced Receipts',
    fields: [
      {
        type: 'radio',
        name: 'INCLUDE_CHEQUEBOUNCE_TABLE',
        id: 'INCLUDE_CHEQUEBOUNCE_TABLE-ALLOWED',
        value: 'ALLOWED',
        label: 'Include',
      },
      {
        type: 'radio',
        name: 'INCLUDE_CHEQUEBOUNCE_TABLE',
        id: 'INCLUDE_CHEQUEBOUNCE_TABLE-DENIED',
        value: 'DENIED',
        label: 'Do Not Include',
      },
    ],
    colSpan: 3,
  },
  TOTAL_TRANSACTION_PER_PAGE_P: {
    label: 'Rows Limit (Portrait)',
    fields: [
      {
        type: 'number',
        name: 'TOTAL_TRANSACTION_PER_PAGE_P',
        id: 'TOTAL_TRANSACTION_PER_PAGE_P',
        min: '1',
        step: '1',
        placeholder: '30',
      },
    ],
    colSpan: 3,
  },
  TOTAL_TRANSACTION_PER_PAGE_L: {
    label: 'Rows Limit (Landscape)',
    fields: [
      {
        type: 'number',
        name: 'TOTAL_TRANSACTION_PER_PAGE_L',
        id: 'TOTAL_TRANSACTION_PER_PAGE_L',
        min: '1',
        step: '1',
        placeholder: '25',
      },
    ],
    colSpan: 3,
  },
  GLOBAL_FONT_SIZE: {
    label: 'Font Size',
    fields: [
      {
        type: 'number',
        name: 'GLOBAL_FONT_SIZE',
        id: 'GLOBAL_FONT_SIZE',
        min: '1',
        step: '0.1',
        placeholder: '18',
      },
    ],
    colSpan: 3,
  },
}

export const PAYMODE_COLLECTION_REPORT_FORM_CONFIG = {
  P_ORIENTATION: {
    label: 'Report Orientation',
    fields: [
      {
        type: 'radio',
        name: 'P_ORIENTATION',
        id: 'P_ORIENTATION-LANDSCAPE',
        value: 'LANDSCAPE',
        label: 'Landscape',
      },
      {
        type: 'radio',
        name: 'P_ORIENTATION',
        id: 'P_ORIENTATION-PORTRAIT',
        value: 'PORTRAIT',
        label: 'Portrait',
      },
    ],
    colSpan: 3,
  },
  P_INCLUDE_FEE_HEADS: {
    label: 'Fee Heads in Report',
    fields: [
      {
        type: 'radio',
        name: 'P_INCLUDE_FEE_HEADS',
        id: 'P_INCLUDE_FEE_HEADS-INCLUDE',
        value: 'INCLUDE',
        label: 'Display Fee Heads With Total',
      },
      {
        type: 'radio',
        name: 'P_INCLUDE_FEE_HEADS',
        id: 'P_INCLUDE_FEE_HEADS-NOT_INCLUDE',
        value: 'NOT_INCLUDE',
        label: 'Do Not Display Fee Heads With Total',
      },
    ],
    colSpan: 3,
  },
  P_HEAD_COL_WIDTH: {
    label: 'Heads Col. Width',
    fields: [
      {
        type: 'number',
        name: 'P_HEAD_COL_WIDTH',
        id: 'P_HEAD_COL_WIDTH',
        min: '5',
        step: '0.1',
      },
    ],
    colSpan: 3,
  },
  P_TOTAL_COL_WIDTH: {
    label: 'Total Col. Width',
    fields: [
      {
        type: 'number',
        name: 'P_TOTAL_COL_WIDTH',
        id: 'P_TOTAL_COL_WIDTH',
        min: '5',
        step: '0.1',
      },
    ],
    colSpan: 3,
  },
  P_SIGN_LABEL1: {
    label: 'Sign Label 1',
    fields: [
      {
        type: 'text',
        name: 'P_SIGN_LABEL1',
        id: 'P_SIGN_LABEL1',
      },
    ],
    colSpan: 3,
  },
  P_SIGN_LABEL2: {
    label: 'Sign Label 2',
    fields: [
      {
        type: 'text',
        name: 'P_SIGN_LABEL2',
        id: 'P_SIGN_LABEL2',
      },
    ],
    colSpan: 3,
  },
  P_SIGN_LABEL3: {
    label: 'Sign Label 3',
    fields: [
      {
        type: 'text',
        name: 'P_SIGN_LABEL3',
        id: 'P_SIGN_LABEL3',
      },
    ],
    colSpan: 3,
  },
}

export const FEE_REPORTS_FORM_CONFIG = {
  REPORT_HEADER_DATA: {
    label: 'Fetch Report Header From',
    fields: [
      {
        type: 'radio',
        name: 'REPORT_HEADER_DATA',
        id: 'REPORT_HEADER_DATA-SCHOOL_CONFIGURATION',
        value: 'SCHOOL_CONFIGURATION',
        label: 'School Configuration',
      },
      {
        type: 'radio',
        name: 'REPORT_HEADER_DATA',
        id: 'REPORT_HEADER_DATA-MASTER_ACCOUNT',
        value: 'MASTER_ACCOUNT',
        label: 'Master Account',
      },
    ],
    colSpan: 3,
  },
}

export const FEE_REMINDER_FORM_CONFIG = {
  FR_OFFICE_NO_1: {
    label: 'Office Contact No. 1',
    fields: [
      {
        type: 'text',
        name: 'FR_OFFICE_NO_1',
        id: 'FR_OFFICE_NO_1',
      },
    ],
    colSpan: 3,
  },

  FR_OFFICE_NO_2: {
    label: 'Office Contact No. 2',
    fields: [
      {
        type: 'text',
        name: 'FR_OFFICE_NO_2',
        id: 'FR_OFFICE_NO_2',
      },
    ],
    colSpan: 3,
  },
  FR_MOBILE_NO_1: {
    label: 'Mobile No. 1',
    fields: [
      {
        type: 'text',
        name: 'FR_MOBILE_NO_1',
        id: 'FR_MOBILE_NO_1',
      },
    ],
    colSpan: 3,
  },
  FR_MOBILE_NO_2: {
    label: 'Mobile No. 2',
    fields: [
      {
        type: 'text',
        name: 'FR_MOBILE_NO_2',
        id: 'FR_MOBILE_NO_2',
      },
    ],
    colSpan: 3,
  },
  FR_NOTE: {
    label: 'Note',
    fields: [
      {
        type: 'text-area',
        rows: '3',
        name: 'FR_NOTE',
        id: 'FR_NOTE',
        maxlength: '960',
        placeholder: 'English & Hindi Supported',
      },
    ],
    colSpan: 3,
  },
  FR_SHOW_QR_CODE: {
    label: 'QR Code Image',
    fields: [
      {
        type: 'radio',
        name: 'FR_SHOW_QR_CODE',
        id: 'FR_SHOW_QR_CODE-SHOW',
        value: 'SHOW',
        label: 'Show',
      },
      {
        type: 'radio',
        name: 'FR_SHOW_QR_CODE',
        id: 'FR_SHOW_QR_CODE-HIDE',
        value: 'HIDE',
        label: 'Hide',
      },
    ],
    colSpan: 3,
  },
  FR_QR_PAYMENT_LINK: {
    label: 'QR Code Payment Link',
    fields: [
      {
        type: 'text-area',
        rows: '3',
        name: 'FR_QR_PAYMENT_LINK',
        id: 'FR_QR_PAYMENT_LINK',
        maxlength: '960',
        placeholder: 'Paste here scanned UPI QR Code link',
      },
    ],
    colSpan: 3,
  },
  FR_PARENT_SIGN_CAPTION: {
    label: 'Sign Caption',
    fields: [
      {
        type: 'text',
        name: 'FR_PARENT_SIGN_CAPTION',
        id: 'FR_PARENT_SIGN_CAPTION',
        placeholder: "Parent's Sign",
      },
    ],
    colSpan: 3,
  },
  FR_FONT_SIZE: {
    label: 'Font Size',
    fields: [
      {
        type: 'number',
        name: 'FR_FONT_SIZE',
        id: 'FR_FONT_SIZE',
        min: '3',
        max: '12',
        step: '0.1',
      },
    ],
    colSpan: 3,
  },
}

export const PETTY_COLLECTION_FORM_CONFIG = {
  PC_BACKDATE_ENTRY: {
    label: 'Petty Collection',
    fields: [
      {
        type: 'radio',
        name: 'PC_BACKDATE_ENTRY',
        id: 'PC_BACKDATE_ENTRY-YES',
        value: 'YES',
        label: 'Yes',
      },
      {
        type: 'radio',
        name: 'PC_BACKDATE_ENTRY',
        id: 'PC_BACKDATE_ENTRY-NO',
        value: 'NO',
        label: 'No',
      },
    ],
    colSpan: 3,
  },
}
